(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FREE = Number(document.body.getAttribute('data-free') || 5000);
  var toast = document.querySelector('.mz-toast');
  var timer;

  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'CAD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n > 0 ? 'false' : 'true');
    });
  }
  function closeToast() { if (toast) toast.classList.remove('is-open'); }
  function openToast(title, msg, img, pct) {
    if (!toast) return;
    toast.querySelector('.mz-toast__title').textContent = title;
    toast.querySelector('.mz-toast__msg').textContent = msg;
    var im = toast.querySelector('img');
    if (img) { im.src = img; im.hidden = false; } else { im.hidden = true; }
    toast.querySelector('.mz-bar i').style.width = (pct == null ? 0 : pct) + '%';
    toast.classList.add('is-open');
    clearTimeout(timer); timer = setTimeout(closeToast, 6000);
  }
  if (toast) {
    toast.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', closeToast); });
  }

  /* Add to cart without leaving the page */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('mz-add')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); btn.textContent = 'Added ✓'; setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 2500); }
        setCount(cart.item_count);
        var left = FREE - cart.total_price;
        openToast('Added to your cart', left > 0 ? 'You’re ' + money(left, cart.currency) + ' away from free shipping.' : 'Your order now ships free.', form.getAttribute('data-img'), Math.min(100, cart.total_price / FREE * 100));
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.textContent = label; }
        openToast('Couldn’t add that item', (err && err.description) || 'Try again in a moment.', null, null);
      });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = Math.max(Number(b.getAttribute('data-qty') === '+' ? 1 : -1) + Number(input.value || 1), Number(input.min || 0));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Pet filter (home) */
  var chips = document.querySelectorAll('.mz-chip[data-filter]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var f = chip.getAttribute('data-filter');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      document.querySelectorAll('.mz-card[data-pet]').forEach(function (card) {
        var pet = card.getAttribute('data-pet');
        card.hidden = !(f === 'all' || pet === f || pet === 'both');
      });
    });
  });

  /* Moment tabs (home) */
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.mz-tab'));
  function selectTab(tab) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }
  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { selectTab(tab); });
    tab.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      if (n) { e.preventDefault(); selectTab(n); n.focus(); }
    });
  });

  /* Product page: gallery + variant picker */
  var main = document.getElementById('mz-main-img');
  document.querySelectorAll('.mz-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) { main.src = t.getAttribute('data-src'); main.removeAttribute('srcset'); }
      document.querySelectorAll('.mz-thumb').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    });
  });
  var vjson = document.getElementById('mz-variants');
  var pform = document.querySelector('.mz-pdp__form');
  if (vjson && pform) {
    var variants = JSON.parse(vjson.textContent);
    var currency = pform.getAttribute('data-currency');
    pform.addEventListener('change', function (e) {
      if (!e.target.matches('[data-opt]')) return;
      var chosen = [];
      pform.querySelectorAll('.mz-opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        chosen.push(c ? c.value : null);
        var lab = fs.querySelector('legend span');
        if (lab && c) lab.textContent = c.value;
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      var btn = pform.querySelector('[type="submit"]');
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      pform.querySelector('input[name="id"]').value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      var price = document.querySelector('.mz-pdp__price');
      if (price) {
        price.innerHTML = '<b>' + money(v.price, currency) + '</b>' + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price, currency) + '</s>' : '');
      }
      if (v.featured_image && main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  }
})();
